import { Typography } from '@mui/material';
import { styled } from '@mui/styles';

export const TypographyCustom = styled(Typography)({
  height: '28px',
  fontSize: '16px',
});
